module.exports = __webpack_public_path__ + "8723ee01b51f245313cb25dbb18596bc.png";